import { useEffect, useState } from "react";
import { Form, Row, Col, InputGroup, Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BasicMachineInformationStruct } from "../../../common/Interfaces";
import { fetchSimToken } from "../../../authentication/AuthenticationHelper";
import { SelectDocumentState } from "../../../routing/RoutingStates";
import { fetchBasicMachineInformations } from "../../../api/sim/BasicMachineInformationService";

export default function SearchSerialNumber() {
  const [serialNumber, setSerialNumber] = useState("");
  const [basicMachineInformations, setBasicMachineInformations] = useState<
    BasicMachineInformationStruct[]
  >([]);
  const [loadingBasicMachineInformation, setLoadingBasicMachineInformation] =
    useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const token = await fetchSimToken();
      if (token) {
        try {
          const basicMachineInformationsList =
            await fetchBasicMachineInformations({
              serialNumber,
              token,
            });
          setBasicMachineInformations(basicMachineInformationsList || []);
        } catch (error: any) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errors = error.response.data.errors;
            const messages = errors.map((err: any) => err.message);
            setErrorMessages(messages);
          }
        } finally {
          setLoadingBasicMachineInformation(false);
        }
      }
    };
    if (loadingBasicMachineInformation && serialNumber.length > 0) {
      fetchData();
    }
  }, [loadingBasicMachineInformation, serialNumber]);

  useEffect(() => {
    if (
      !loadingBasicMachineInformation &&
      basicMachineInformations.length > 0
    ) {
      const selectDocumentState: SelectDocumentState = {
        basicMachineInformationResults: basicMachineInformations,
        documentResults: [],
      };
      navigate("SearchSerialNumber", {
        state: { selectDocumentState },
      });
    }
  }, [loadingBasicMachineInformation, basicMachineInformations]);

  const handleSerialNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setErrorMessages([]);
    setSerialNumber(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (serialNumber.length > 0) {
      setLoadingBasicMachineInformation(true);
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row className="padding-top">
          <Col xs={2}>
            <Form.Label key="title">Search Serial Number</Form.Label>
          </Col>
          <Col xs={4}>
            <InputGroup className="no-padding" key="search-serialNumber">
              <Form.Control
                placeholder="Enter Serial Number"
                value={serialNumber}
                onChange={handleSerialNumberChange}
              />
            </InputGroup>
            {errorMessages.map((errorMessage, index) => (
              <label key={index} className="errorMessage">
                {errorMessage}
              </label>
            ))}
          </Col>
          <Col xs={2}>
            {loadingBasicMachineInformation ? (
              <Spinner animation="border" />
            ) : (
              <Button type="submit">Search</Button>
            )}
          </Col>
        </Row>
      </Form>
    </>
  );
}
